function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTreemap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 600 600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1055.51,-907.035)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.17188,0,0,1.17188,1055.51,907.035)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.998014,0,0,0.997283,0.459011,1.35509)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.46,
    y: -1.359,
    width: 256.51,
    height: 513.395,
    style: {
      fill: "rgb(2,219,140)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.109158,0,0,0.99657,228.05,1.35412)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.46,
    y: -1.359,
    width: 256.51,
    height: 513.395,
    style: {
      fill: "rgb(0,172,109)"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 0,
    width: 256,
    height: 255.817,
    style: {
      fill: "rgb(61,87,211)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.109375,0,0,1,456,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 0,
    width: 256,
    height: 255.817,
    style: {
      fill: "rgb(31,63,217)"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 256,
    width: 128,
    height: 255.634,
    style: {
      fill: "rgb(253,156,76)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21875,0,0,1,300,0.366321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 256,
    width: 128,
    height: 255.634,
    style: {
      fill: "rgb(255,127,22)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,128,-0.366321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 256,
    width: 128,
    height: 255.634,
    style: {
      fill: "rgb(243,205,81)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.21875,0,0,1,428,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 256,
    width: 128,
    height: 255.634,
    style: {
      fill: "rgb(249,190,0)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.701263,0,0,0.701263,74.2959,72.1122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.262,232.198C341.262,226.296 336.47,221.503 330.567,221.503L285.725,221.503C279.822,221.503 275.03,226.296 275.03,232.198C275.03,238.101 279.822,242.893 285.725,242.893L330.567,242.893C336.47,242.893 341.262,238.101 341.262,232.198Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.701263,0,0,0.701263,74.2959,327.165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.262,232.198C341.262,226.296 336.47,221.503 330.567,221.503L285.725,221.503C279.822,221.503 275.03,226.296 275.03,232.198C275.03,238.101 279.822,242.893 285.725,242.893L330.567,242.893C336.47,242.893 341.262,238.101 341.262,232.198Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.701263,0,0,0.701263,201.114,327.165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.262,232.198C341.262,226.296 336.47,221.503 330.567,221.503L285.725,221.503C279.822,221.503 275.03,226.296 275.03,232.198C275.03,238.101 279.822,242.893 285.725,242.893L330.567,242.893C336.47,242.893 341.262,238.101 341.262,232.198Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.701263,0,0,0.701263,-176.241,327.165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.262,232.198C341.262,226.296 336.47,221.503 330.567,221.503L285.725,221.503C279.822,221.503 275.03,226.296 275.03,232.198C275.03,238.101 279.822,242.893 285.725,242.893L330.567,242.893C336.47,242.893 341.262,238.101 341.262,232.198Z",
    style: {
      fill: "white"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreemap);
export default __webpack_public_path__ + "static/media/treemap.c58a91b24bc2236862c796c8ff2e89bf.svg";
export { ForwardRef as ReactComponent };